import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'create-category',
  templateUrl: 'create-category.component.html'
})
export class CreateCategoryComponent {
  category = new FormGroup({
    name: new FormControl('', Validators.required),
    icon: new FormControl('', Validators.required)
  });

  constructor(
    public dialogRef: MatDialogRef<CreateCategoryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  onCancel(): void {
    this.dialogRef.close();
  }

  onSubmit() {
    if (this.category.valid) {
      this.dialogRef.close(this.category.value);
    }
  }
}
